/**
 * Zoho CRM connection (scope M13): the redirect contract with the API
 * (`backend/app/core/constants/zoho.py`) and the only hosts the console follows for consent.
 */

/** `IntegrationKey` of the Zoho CRM integration row. */
export const ZOHO_INTEGRATION_KEY = "zoho";

/**
 * Zoho's per-region accounts hosts: the only https destinations the console navigates to when a
 * member connects Zoho. The patterns differ per region, so each host is listed in full.
 */
export const ZOHO_ACCOUNTS_HOSTS = [
  "accounts.zoho.com",
  "accounts.zoho.eu",
  "accounts.zoho.in",
  "accounts.zoho.com.au",
  "accounts.zoho.jp",
  "accounts.zoho.sa",
  "accounts.zoho.com.cn",
  "accounts.zohocloud.ca",
] as const;

/** Where Zoho sends the browser after consent; the API answers it (offline fake: the consent URL itself). */
export const ZOHO_CALLBACK_PATH = "/v1/integrations/zoho/callback";

/** The API redirects back to Settings > Integrations with `?zoho=connected` or `?zoho=error&reason=...`. */
export const ZOHO_RETURN_PARAM = "zoho";
export const ZOHO_REASON_PARAM = "reason";
export const ZOHO_RETURN_CONNECTED = "connected";
export const ZOHO_RETURN_ERROR = "error";

/** Why a connect attempt ended (the only detail the browser ever gets). */
export const ZOHO_RETURN_REASONS = ["denied", "expired", "failed", "no_refresh", "scope", "unavailable", "forbidden"] as const;
export type ZohoReturnReason = (typeof ZOHO_RETURN_REASONS)[number];
